import { authorizedFetch } from '../../utils/api';

const BASE = '/api/personalize/invest';

const ADMIN_BASE = '/api/personalize/control';

export const ordersApi = {
  getOrderHistory({ provider, status, fromDate, toDate, page = 0, size = 20 } = {}) {
    const params = new URLSearchParams();
    if (provider) params.set('provider', provider);
    if (status) params.set('status', status);
    if (fromDate) params.set('fromDate', fromDate);
    if (toDate) params.set('toDate', toDate);
    params.set('page', String(page));
    params.set('size', String(size));
    return authorizedFetch(`${BASE}/orders/history?${params.toString()}`);
  },

  getOrderDetail(orderId) {
    return authorizedFetch(`${BASE}/orders/${orderId}`);
  },

  approveOrder(orderId) {
    return authorizedFetch(`${ADMIN_BASE}/brokerage-order/approve/${orderId}`, {
      method: 'POST',
    });
  },

  confirmPayment(provider, orderId) {
    return authorizedFetch(`${BASE}/orders/${provider}/confirm-payment`, {
      method: 'POST',
      body: JSON.stringify({ order_id: orderId }),
    });
  },

  getWebviewAccess(provider) {
    return authorizedFetch(`${BASE}/webview/${provider}`);
  },

  syncOrderStatus(orderId) {
    return authorizedFetch(`${ADMIN_BASE}/brokerage-order/sync-status/${orderId}`, {
      method: 'POST',
    });
  },
};
